var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.2385 21.6707C38.2385 12.0129 30.4568 4.18359 20.8575 4.18359C11.2583 4.18359 3.47656 12.0129 3.47656 21.6707C3.47656 30.3989 9.8325 37.6336 18.1417 38.9455V26.7256H13.7286V21.6707H18.1417V17.8181C18.1417 13.4354 20.7367 11.0145 24.7067 11.0145C26.6085 11.0145 28.5974 11.3561 28.5974 11.3561V15.6596H26.4059C24.2468 15.6596 23.5733 17.0076 23.5733 18.3906V21.6707H28.3937L27.6232 26.7256H23.5733V38.9455C31.8826 37.6336 38.2385 30.3993 38.2385 21.6707Z",
    fill: "#161614"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.cf56884f807746427ddc2cf3d53ba639.svg";
export { ForwardRef as ReactComponent };